module.exports = __webpack_public_path__ + "static/icon4-b1c84dcfe1ee3607a7ce0c7b76eea48f.svg";